import { Box, Typography, useTheme, alpha } from '@mui/material'
import { PageBannerContext } from '../../context/PageBannerContext'
import { PageDivider } from '../../components/pageDivider/pageDivider'
import { BaseImage } from '../../components/baseImage/baseImage'

export const PageBanner = ({ children, mode = 'default', ...props }) => {
  const theme = useTheme()

  return (
    <PageBannerContext.Provider value={true}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          overflow: 'hidden',
          backgroundColor: '#b7b9d0',
          //backgroundImage: { xs: 'none', md: 'url(/images/heronew/hero-bg.webp)' },
          backgroundImage: 'url(/images/heronew/hero-bg.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'bottom center',
          backgroundRepeat: 'no-repeat',
          position: 'relative',
        }}
        data-model-id="204:595"
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: { xs: '196px', md: '172px' },
            overflow: 'hidden',
          }}
        >
          {mode == 'default' && (
            <Box sx={{ position: 'absolute', bottom: 0, left: 0, width: { xs: '360px', md: '354px' }, transform: { xs: 'translateY(-1px)', md: 'none' } }}>
              <BaseImage
                alt=""
                src="/images/heronew/hero-trees-l.webp"
                width="1040"
                height="508"
                sources={[<source key="m" media="(max-width: 899px)" srcSet="/images/heronew/hero-trees-l-mobile.webp" />]}
                sx={{ 
                  width: '100%', 
                  height: 'auto', 
                  display: 'block',
                }}
              />
            </Box>
          )}
          {mode == 'pair' && (
            <>
              <Box sx={{
                position: 'absolute',
                bottom: 0,
                left: { xs: 'clamp(-180px, calc(50vw - 360px), 0px)', md: 'auto' },
                right: { xs: 'auto', md: 'calc(100vw - 350px)' },
                width: { xs: '360px', md: '354px' },
                transform: { xs: 'translateY(-1px)', md: 'none' }
              }}>
                <BaseImage
                  alt=""
                  src="/images/heronew/hero-trees-l.webp"
                  width="1040"
                  height="508"
                  sources={[<source key="m" media="(max-width: 899px)" srcSet="/images/heronew/hero-trees-l-mobile.webp" />]}
                  sx={{ width: '100%', height: 'auto', display: 'block' }}
                />
              </Box>
              <Box sx={{
                position: 'absolute',
                bottom: 0,
                left: 'clamp(calc(100% - 360px), 50%, calc(100% - 100px))',
                width: { xs: '380px', md: '370px' },
                transform: { xs: 'translateY(-1px)', md: 'none' }
              }}>
                <BaseImage
                  alt=""
                  src="/images/heronew/hero-trees-r.webp"
                  width="1078"
                  height="502"
                  sources={[<source key="m" media="(max-width: 899px)" srcSet="/images/heronew/hero-trees-r-mobile.webp" />]}
                  sx={{ width: '100%', height: 'auto', display: 'block' }}
                />
              </Box>
              <Box sx={{
                position: 'absolute',
                bottom: 0,
                left: { xs: 'clamp(-20px, 35vw - 154px, 154px)', md: 'clamp(0px, 35vw, 154px)' },
                width: { xs: '170px', md: '180px' },
                transform: { xs: 'translateY(-1px)', md: 'none' }
              }}>
                <BaseImage
                  alt=""
                  src="/images/heronew/hero-subject.webp"
                  width="546"
                  height="496"
                  sources={[<source key="m" media="(max-width: 899px)" srcSet="/images/heronew/hero-subject-mobile.webp" />]}
                  sx={{ width: '100%', height: 'auto', display: 'block' }}
                />
              </Box>
            </>
          )}
          <Box
            alt=""
            sx={{
              position: 'absolute',
              width: '100%',
              height: '20px',
              display: { xs: 'block', md: 'none' },
              left: 0,
              background: theme.palette.secondary.main,
            }}
          />

          <Box
            component="img"
            src="/images/hero/green-holding-shape.svg"
            alt=""
            sx={{
              position: 'absolute',
              width: 'auto',
              height: { xs: '44px', md: '66px' },
              top: { xs: 20, md: 0 },
              left: 0,
            }}
          />

          <Box
            className="content-header"
            sx={{
              display: 'flex',
              //maxWidth: '900px',
              width: '100%',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: 2.5,
              padding: '0',
              height: '133px',
              margin: 0,
              left: 0,
              backgroundColor: 'transparent',
            }}
          >
            <Typography
              className="label"
              variant="h1"
              sx={(theme) => ({
                right: 0,
                position: 'absolute',
                bottom: { xs: theme.spacing(3), md: 'unset' },
                width: { xs: mode === 'pair' ? '50%' : '95%', md: '60%' },
                lineHeight: 1,
                fontWeight: 700,
                color: 'white',
                backgroundColor: alpha(theme.palette.tertiary.main, 0.8),
                fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.75em' },
                padding: { xs: theme.spacing(2, 1), md: theme.spacing(2, 2, 2, 4) },
                borderRadius: theme.spacing(4, 0, 0, 4),
                textAlign: { xs: 'right', md: 'left' },
                margin: 0,
              })}
            >
              {children}
            </Typography>
          </Box>
        </Box>
      </Box>

      <PageDivider flat
        progress="75%"
        sx={{
          width: '100%',
          margin: theme.spacing(0, 0, 2),
          bottom: '0px',
          left: 0,
        }}
      />
    </PageBannerContext.Provider>
  )
}
